// extracted by mini-css-extract-plugin
module.exports = {"Logo":"ResursLogo_Logo__OTAOe"};